<template>
  <SolutionPageLayout title="Associations" section="Sectors">
    <p>
      Member-based organisations often run annual conferences, chapter meetings, and training with recurring audiences and evolving programmes.
    </p>
    <p>
      Entegy helps associations grow engagement year on year: streamlined registration, member-friendly portals, and tools that make volunteers and staff more productive.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
